export enum SystemMessageSeverity {
  Info = 0,
  Warning = 1,
  Critical = 2,
}

export interface VersionInfo {
  latest: string;
  minimum: string;
}

export interface MaintenanceInfo {
  isActive: boolean;
  message: string;
}

export interface SystemMessageInfo {
  title: string;
  message: string;
  severity: SystemMessageSeverity;
}

export interface AppStateDto {
  mobile: VersionInfo;
  web: VersionInfo;
  maintenanceMobile: MaintenanceInfo;
  maintenanceWeb: MaintenanceInfo;
  systemMessageWeb: SystemMessageInfo | null;
  systemMessageMobile: SystemMessageInfo | null;
}

export interface WebAppState {
  version: VersionInfo;
  maintenance: MaintenanceInfo;
  systemMessage: SystemMessageInfo | null;
}

export type AppStateCheckResult =
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'maintenance'; message: string }
  | { status: 'force-update'; currentVersion: string; minimumVersion: string }
  | {
      status: 'ok';
      optionalUpdate: boolean;
      latestVersion: string | null;
      systemMessage: SystemMessageInfo | null;
    };
